import axiosInstance from './axiosInstance';

// Cache pro uložené URL odznaků
const badgeCache = new Map();

const createTeam = async (team) => {
  try {
    const response = await axiosInstance.post('/teams', team);
    return response.data;
  } catch (error) {
    console.error('Error creating team:', error);
    throw new Error('Failed to create team');
  }
};

const getAllTeams = async () => {
  try {
    const response = await axiosInstance.get('/teams');
    return response.data;
  } catch (error) {
    console.error('Error fetching teams:', error);
    throw new Error('Failed to fetch teams');
  }
};

const getTeamBadge = async (teamId) => {
  // Pokud je badge již v cache, vrátíme ho přímo
  if (badgeCache.has(teamId)) {
    return badgeCache.get(teamId);
  }

  try {
    const response = await axiosInstance.get(`/teams/${teamId}/badge`, {
      responseType: 'blob',
    });

    const badgeUrl = URL.createObjectURL(response.data);

    // Uložení URL do cache pro budoucí použití
    badgeCache.set(teamId, badgeUrl);

    return badgeUrl;
  } catch (error) {
    console.error(`Error fetching badge for team ID ${teamId}:`, error);
    throw new Error('Failed to fetch team badge');
  }
};

// Funkce pro vyčištění cache - volejte při odchodu z aplikace nebo když už není potřeba
const clearBadgeCache = (teamId = null) => {
  if (teamId) {
    // Vyčistit cache jen pro konkrétní tým
    if (badgeCache.has(teamId)) {
      URL.revokeObjectURL(badgeCache.get(teamId));
      badgeCache.delete(teamId);
    }
  } else {
    // Vyčistit celou cache
    badgeCache.forEach(url => URL.revokeObjectURL(url));
    badgeCache.clear();
  }
};

const getLastMatchesByTeam = async (teamId) => {
  try {
    const response = await axiosInstance.get(`/teams/${teamId}/last-matches?count=20`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching last matches for team ID ${teamId}:`, error);
    throw new Error('Failed to fetch last matches');
  }
};

export default {
  createTeam,
  getAllTeams,
  getTeamBadge,
  clearBadgeCache,
  getLastMatchesByTeam
};